import html2canvas from "html2canvas";

//  HTML GENERATOR
export const generateReceiptHTML = (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  const successTickBase64 =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA0CAYAAAA3xE5O..."; // short for clarity (same rakho)

  return `
    <html>
    <head>
      <style>
        body { font-family: Arial; }
        .container { max-width:600px; }
      </style>
    </head>

    <body>
      <div class="container">

        <h3>${reciptDetails.business_name}</h3>
        <p>${reciptDetails.address}</p>
        <p>Phone: ${reciptDetails.phone_no}</p>

        <h2 style="text-align:center;">Order Dispatched!</h2>

        <p>Order: ${item.daily_order_id}/${item.orderid}</p>
        <p>Name: ${item.customer_name}</p>
        <p>Mobile: ${item.customer_mobile}</p>
        <p>Address: ${fullAddress}</p>

        <hr/>

        <table style="width:100%">
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Total</th>
          </tr>

          ${
            item.items
              ?.map(
                (i) => `
              <tr>
                <td>${i.product_id}</td>
                <td>${i.quantity}</td>
                <td>${i.total_price}</td>
              </tr>
            `
              )
              .join("")
          }
        </table>

        <hr/>

        <p>Total: Rs. ${item.totalOrderPrice}</p>

        <p style="text-align:center;">Thank you!</p>

      </div>
    </body>
    </html>
  `;
};

//  PNG GENERATOR
export const generatePNG = async (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  const tempDiv = document.createElement("div");

  tempDiv.innerHTML = generateReceiptHTML(
    item,
    fullAddress,
    organizationDetails,
    reciptDetails
  );

  tempDiv.style.width = "600px";
  tempDiv.style.position = "absolute";
  tempDiv.style.left = "-9999px";

  document.body.appendChild(tempDiv);

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      html2canvas(tempDiv, {
        width: 600,
        scale: 2,
      })
        .then((canvas) => {
          const base64 = canvas.toDataURL("image/png").split(",")[1];
          document.body.removeChild(tempDiv);
          resolve(base64);
        })
        .catch((err) => {
          document.body.removeChild(tempDiv);
          reject(err);
        });
    }, 50);
  });
};